/**
 * ThemeContext — sempre Total Dark
 * Il tema light è stato rimosso. La piattaforma usa esclusivamente il tema scuro.
 */

import React, { createContext, useContext, useEffect } from 'react';

export type AppTheme = 'dark';

interface ThemeContextValue {
  theme: AppTheme;
}

const ThemeContext = createContext<ThemeContextValue>({ theme: 'dark' });

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    // Forza sempre il tema scuro e pulisce eventuali preferenze salvate
    document.documentElement.setAttribute('data-theme', 'dark');
    localStorage.removeItem('tradingspace_theme');
  }, []);

  return (
    <ThemeContext.Provider value={{ theme: 'dark' }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
